export default {
  getAuditLogsList: (state: any) => state.auditLogsList,
  getAuditLogsList_all: (state: any) => state.auditLogsList_all,
};
